module.exports = __webpack_public_path__ + "static/img/bulk-empty@2x.2e775a58.png";